import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: 20,
    },
    listContainer: {
      paddingTop: 0,
    },
    btnFilter: {
      textTransform: "capitalize",
      fontSize: 14,
      backgroundColor: "rgba(106, 70, 229, 0.8)",
      width: "100%",
      borderColor: "#6A46E5 !important",
      "&:hover": {
        backgroundColor: "#6A46E5",
      },
      paddingLeft: "6px !important",
      paddingRight: "6px !important",
    },
    btnActive: {
      backgroundColor: "#6A46E5 !important",
    },
    totalVolunteerTime: {
      marginTop: 10,
      marginBottom: 8,
      display: "flex",
      gap: 6,
    },
    groupBtns: {
      width: "100%",
    },
    /** Keep tabs and filters fixed while scrolling (sticky app bar at ~44px) */
    stickyFiltersBar: {
      position: "sticky",
      top: 44,
      zIndex: 1100,
      backgroundColor: "#fff",
      borderBottom: "1px solid #e0e0e0",
    },
    emptyMyRankMessage: {
      padding: theme.spacing(3, 2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
  })
);

export default useStyles;
